import styles from "./LoginSidebar.module.scss";

export const LoginTypeSwitcher = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles.sidebarWrapper__logButtonsBlock}>
      <div
        className={
          activeTab === "sign-in"
            ? styles.sidebarWrapper__logBtnActive
            : styles.sidebarWrapper__logBtn
        }
        onClick={() => onTabChange("sign-in")}
      >
        <p>Вход</p>
      </div>
      <div
        className={
          activeTab === "registration"
            ? styles.sidebarWrapper__logBtnActive
            : styles.sidebarWrapper__logBtn
        }
        onClick={() => onTabChange("registration")}
      >
        <p>Регистрация</p>
      </div>
    </div>
  );
};
